import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, Outlet } from 'react-router-dom';
import Sidebar from './components/Sidebar';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Projects from './pages/Projects';
import Events from './pages/Events';
import Gallery from './pages/Gallery';
import Donations from './pages/Donations';
import Blogs from './pages/Blogs';
import News from './pages/News';
import Contacts from './pages/Contacts';
import Volunteers from './pages/Volunteers';
import HomeSettings from './pages/HomeSettings';
import Profile from './pages/Profile';
import Campaigns from './pages/Campaigns';
import AdvisoryBoard from './pages/AdvisoryBoard';
import PopupAnnouncements from './pages/PopupAnnouncements';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './styles/index.css';

const isAuthenticated = () => !!localStorage.getItem('adminToken');

const ProtectedRoute = ({ children }) => {
    if (!isAuthenticated()) {
        return <Navigate to="/admin/login" replace />;
    }
    return children;
};

const AdminLayout = () => (
    <div className="flex bg-gray-100 min-h-screen">
        <Sidebar />
        <main className="flex-1 p-8">
            <Outlet />
        </main>
    </div>
);

function App() {
    return (
        <Router>
            <Routes>
                <Route path="/admin/login" element={<Login />} />
                <Route
                    path="/admin"
                    element={
                        <ProtectedRoute>
                            <AdminLayout />
                        </ProtectedRoute>
                    }
                >
                    <Route index element={<Navigate to="dashboard" replace />} />
                    <Route path="dashboard" element={<Dashboard />} />
                    <Route path="projects" element={<Projects />} />
                    <Route path="events" element={<Events />} />
                    <Route path="gallery" element={<Gallery />} />
                    <Route path="campaigns" element={<Campaigns />} />
                    <Route path="advisory-board" element={<AdvisoryBoard />} />
                    <Route path="popups" element={<PopupAnnouncements />} />
                    <Route path="news" element={<News />} />
                    <Route path="blogs" element={<Blogs />} />
                    <Route path="donations" element={<Donations />} />
                    <Route path="contacts" element={<Contacts />} />
                    <Route path="volunteers" element={<Volunteers />} />
                    <Route path="home-settings" element={<HomeSettings />} />
                    <Route path="profile" element={<Profile />} />
                </Route>
                <Route path="/" element={<Navigate to="/admin/login" replace />} />
                <Route path="*" element={<Navigate to="/admin/login" replace />} />
            </Routes>
            <ToastContainer position="top-right" autoClose={3000} hideProgressBar={false} />
        </Router>
    );
}

export default App;
